/**
 * Clickable header row of the On track bucket card: check badge icon, label, total count
 * (always visible, even at 0) and a chevron that reflects the popup's open state. It is the
 * floating-ui reference element, so open/close (click + keyboard) is driven by the trigger props.
 */
import { observer } from "mobx-react";
import { Ref } from "react";
import FontBody2 from "../../../../../../../../../../../components/fonts/font-body2/font-body2";
import IconBucketOnTrack from "../../../../../../../../../../../components/icons/icon-bucket-on-track/icon-bucket-on-track";
import IconChevronDown from "../../../../../../../../../../../components/icons/icon-chevron-down/icon-chevron-down";

interface IProps {
    label: string;
    total: number;
    /** Counters are being recomputed: the previous number stays, dimmed, so the card does not reflow. */
    loading: boolean;
    open: boolean;
    disabled: boolean;
    triggerRef: Ref<HTMLDivElement>;
    triggerProps: Record<string, unknown>;
}

const RmaListOnTrackBucketCardRow: React.FC<IProps> = observer(({ label, total, loading, open, disabled, triggerRef, triggerProps }) => (
    <div
        ref={triggerRef}
        role="button"
        tabIndex={disabled ? -1 : 0}
        className="rma-list-on-track-bucket__row"
        {...triggerProps}
    >
        <span className="rma-list-on-track-bucket__icon">
            <IconBucketOnTrack />
        </span>
        <FontBody2>{label}</FontBody2>
        <span className={`rma-list-on-track-bucket__count${loading ? " loading" : ""}`}>{total}</span>
        <span className={`rma-list-on-track-bucket__chevron${open ? " open" : ""}`}>
            <IconChevronDown color="var(--color-primary-2-50)" />
        </span>
    </div>
));

export default RmaListOnTrackBucketCardRow;
